module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA0ElEQVR4AWOgC1DpCrWbxUAMggLG4jN6E0xJ0MBQfI6l9JDpFFkSNACRSvvVD9///AeD71+ff3hx5tPLc5/eXPn399d/GEBogCCn6bf//P0HlPjz+9uW63uStlbfenHj/7+/WDTAkXH/DaDE37//Lj66sufs9nffPv/79w+fDT//gKRfvnz17P7du+dOPH36/Pv373AN6H54+xXqh0+fPt27d+/OnTvPnj37+xebk3jzDh/QM3msKIEfQdUzF51ZZu4J5BOrodklFcInrGFQAgCMOP3bLVZxOQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/GQ.png
// module id = 1152
// module chunks = 0